<style src="./style.scss">
</style>

<script lang="ts">
  import Modal from "@components/modal";
  import Button from "@components/button";
  import TextInput from "@components/textInput";

  export let isOpen = false;
  export let onClose = () => null;
  export let onSubmit = () => null;
  export let name: string = "";
</script>

<Modal isOpen="{isOpen}" title="Mudar nome e sobrenome" onClose="{onClose}">
  <form on:submit|preventDefault="{() => onSubmit(name)}">
    <TextInput placeholder="Nome e sobrenome" bind:value="{name}" type="text" />

    <Button
      title="Salvar"
      onClick="{() => onSubmit(name)}"
      disabled="{!name}" />
  </form>
</Modal>
